"use strict";
import { __exports as r } from "./index.es532.js";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w;
function re() {
  return w ? r : (w = 1, process.env.NODE_ENV !== "production" && (function() {
    var o = typeof Symbol == "function" && Symbol.for, d = o ? Symbol.for("react.element") : 60103, b = o ? Symbol.for("react.portal") : 60106, n = o ? Symbol.for("react.fragment") : 60107, c = o ? Symbol.for("react.strict_mode") : 60108, a = o ? Symbol.for("react.profiler") : 60114, f = o ? Symbol.for("react.provider") : 60109, s = o ? Symbol.for("react.context") : 60110, S = o ? Symbol.for("react.async_mode") : 60111, u = o ? Symbol.for("react.concurrent_mode") : 60111, i = o ? Symbol.for("react.forward_ref") : 60112, y = o ? Symbol.for("react.suspense") : 60113, x = o ? Symbol.for("react.suspense_list") : 60120, l = o ? Symbol.for("react.memo") : 60115, m = o ? Symbol.for("react.lazy") : 60116, h = o ? Symbol.for("react.block") : 60121, C = o ? Symbol.for("react.fundamental") : 60117, E = o ? Symbol.for("react.responder") : 60118, P = o ? Symbol.for("react.scope") : 60119;
    function R(e) {
      return typeof e == "string" || typeof e == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      e === n || e === u || e === a || e === c || e === y || e === x || typeof e == "object" && e !== null && (e.$$typeof === m || e.$$typeof === l || e.$$typeof === f || e.$$typeof === s || e.$$typeof === i || e.$$typeof === C || e.$$typeof === E || e.$$typeof === P || e.$$typeof === h);
    }
    function t(e) {
      if (typeof e == "object" && e !== null) {
        var $ = e.$$typeof;
        switch ($) {
          case d:
            var p = e.type;
            switch (p) {
              case S:
              case u:
              case n:
              case a:
              case c:
              case y:
                return p;
              default:
                var _ = p && p.$$typeof;
                switch (_) {
                  case s:
                  case i:
                  case m:
                  case l:
                  case f:
                    return _;
                  default:
                    return $;
                }
            }
          case b:
            return $;
        }
      }
    }
    var g = S, A = u, F = s, I = f, j = d, z = i, L = n, N = m, O = l, T = b, V = a, k = c, q = y, v = !1;
    function D(e) {
      return v || (v = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(e) || t(e) === S;
    }
    function M(e) {
      return t(e) === u;
    }
    function U(e) {
      return t(e) === s;
    }
    function B(e) {
      return t(e) === f;
    }
    function G(e) {
      return typeof e == "object" && e !== null && e.$$typeof === d;
    }
    function H(e) {
      return t(e) === i;
    }
    function J(e) {
      return t(e) === n;
    }
    function K(e) {
      return t(e) === m;
    }
    function Q(e) {
      return t(e) === l;
    }
    function W(e) {
      return t(e) === b;
    }
    function X(e) {
      return t(e) === a;
    }
    function Y(e) {
      return t(e) === c;
    }
    function Z(e) {
      return t(e) === y;
    }
    r.AsyncMode = g, r.ConcurrentMode = A, r.ContextConsumer = F, r.ContextProvider = I, r.Element = j, r.ForwardRef = z, r.Fragment = L, r.Lazy = N, r.Memo = O, r.Portal = T, r.Profiler = V, r.StrictMode = k, r.Suspense = q, r.isAsyncMode = D, r.isConcurrentMode = M, r.isContextConsumer = U, r.isContextProvider = B, r.isElement = G, r.isForwardRef = H, r.isFragment = J, r.isLazy = K, r.isMemo = Q, r.isPortal = W, r.isProfiler = X, r.isStrictMode = Y, r.isSuspense = Z, r.isValidElementType = R, r.typeOf = t;
  })(), r);
}
export {
  re as __require
};
//# sourceMappingURL=index.es523.js.map
